import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  title: "",
  text: "",
  show: false,
  icon: null
};

export const errorSlice = createSlice({
  name: 'errorManager',
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    showError: (state, action) => {
        console.log(action)
    },
    hideErrorModal: (state) => {
        state.show = false
    },
  },
});

export const { showError, hideErrorModal } = errorSlice.actions;

export const selectErrorData = (state) => state.errorManager;

export default errorSlice.reducer;
